import React, { useState } from 'react'
import { CBadge, CSmartTable } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilNewspaper } from '@coreui/icons'
import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import RowActionsMenu from 'src/components/common/RowActionsMenu'
import ArticleService from 'src/service/ArticleService'
import Notify from '../Notify'

const API_URL = process.env.REACT_APP_API_URL

const columns = [
  { key: 'title', label: 'Article', filter: false, sorter: true },
  { key: 'is_active', label: 'Status', filter: false, sorter: false, _style: { width: '16%' } },
  { key: 'created_at', label: 'Created', filter: false, sorter: true, _style: { width: '16%' } },
  { key: 'actions', label: 'Actions', filter: false, sorter: false, _style: { width: '1%' } },
]

const Table = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnSorter,
  loading,
  onEditArticle,
}) => {
  const [actionLoading, setActionLoading] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [tableId, setTableId] = useState(null)

  const deleteArticle = (id) => {
    setActionLoading(true)
    ArticleService.deleteArticle({ id })
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .finally(() => setActionLoading(false))
  }

  const handleStatus = (id, status) => {
    setActionLoading(true)
    ArticleService.updateStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .finally(() => setActionLoading(false))
  }

  const handleCancel = () => setShowConfirm(false)
  const handleConfirm = () => {
    deleteArticle(tableId)
    setShowConfirm(false)
  }
  const areYouSureModal = (id) => {
    setShowConfirm(true)
    setTableId(id)
  }

  const totalPages = Math.ceil((users?.total || 0) / itemsPerPage)

  return (
    <div className="ge-datatable ge-datatable--no-select">
      <CSmartTable
        columns={columns}
        columnSorter={{ external: true }}
        sorterValue={columnSorter}
        noItemsLabel="No articles yet"
        scopedColumns={{
          title: (item) => (
            <td>
              <div className="at-article-cell">
                {item.image ? (
                  <img
                    className="at-article-thumb"
                    src={`${API_URL}uploads/articles/${item.image}`}
                    alt={item.title}
                    onError={(e) => {
                      e.target.style.display = 'none'
                    }}
                  />
                ) : (
                  <span className="at-article-thumb at-article-thumb--empty">
                    <CIcon icon={cilNewspaper} size="sm" />
                  </span>
                )}
                <div className="d-flex flex-column">
                  <span
                    className="fw-semibold text-primary"
                    role="button"
                    onClick={() => onEditArticle(item.id)}
                  >
                    {item.title}
                  </span>
                  {item.link && <span className="at-article-link">{item.link}</span>}
                </div>
              </div>
            </td>
          ),
          is_active: (item) => (
            <td>
              <CBadge
                color={item.is_active === 1 ? 'success' : 'warning'}
                shape="rounded-pill"
                className="px-2 py-1"
              >
                {item.is_active === 1 ? 'Activated' : 'Deactivated'}
              </CBadge>
            </td>
          ),
          created_at: (item) => (
            <td>{item.created_at ? moment(item.created_at).format('D.MM.YYYY') : '-'}</td>
          ),
          actions: (item) => (
            <td>
              <RowActionsMenu
                actions={[
                  { label: 'Edit', onClick: () => onEditArticle(item.id) },
                  item.is_active === 1
                    ? {
                        label: 'Deactivate',
                        disabled: actionLoading,
                        onClick: () => handleStatus(item.id, 0),
                      }
                    : {
                        label: 'Activate',
                        disabled: actionLoading,
                        onClick: () => handleStatus(item.id, 1),
                      },
                  { label: 'Delete', danger: true, onClick: () => areYouSureModal(item.id) },
                ]}
              />
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading || actionLoading}
        pagination={{ external: true }}
        paginationProps={{
          activePage,
          pages: totalPages || 1,
        }}
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(page) => setActivePage(page)}
        onItemsPerPageChange={(perPage) => {
          setActivePage(1)
          setItemsPerPage(perPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        showConfirm={showConfirm}
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        text="Are you sure you want to delete this article?"
      />
    </div>
  )
}

export default Table
